"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOAST_VARIANTS = exports.Toast = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Clickable = require("../Clickable");

var _Text = require("../Text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Toast = function Toast(_ref) {
  var id = _ref.id,
      action = _ref.action,
      description = _ref.description,
      message = _ref.message,
      onClose = _ref.onClose,
      rest = _objectWithoutProperties(_ref, ["id", "action", "description", "message", "onClose"]);

  var handleClick = function handleClick() {
    onClose === null || onClose === void 0 ? void 0 : onClose(id);
  };

  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    width: "100%",
    px: 2,
    py: 1,
    bg: "black100",
    color: "white100",
    role: "button",
    tabIndex: 0,
    onClick: handleClick,
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter" || event.key === " ") {
        onClose === null || onClose === void 0 ? void 0 : onClose(id);
      }
    },
    style: {
      cursor: "pointer"
    }
  }, rest), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    alignItems: "flex-start",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "md"
  }, message), action && /*#__PURE__*/_react.default.createElement(_Clickable.Clickable, {
    onClick: action.onClick,
    textDecoration: "underline",
    color: "rgba(255, 255, 255, 0.9)"
  }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs"
  }, action.label))), description && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs"
  }, description));
};

exports.Toast = Toast;
Toast.displayName = "Toast";
var TOAST_VARIANTS = {
  message: {
    backgroundColor: "black100",
    color: "white100"
  },
  alert: {
    backgroundColor: "blue100",
    color: "white100"
  },
  success: {
    backgroundColor: "green100",
    color: "white100"
  },
  error: {
    backgroundColor: "red100",
    color: "white100"
  }
};
exports.TOAST_VARIANTS = TOAST_VARIANTS;
var Container = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Toast__Container",
  componentId: "sc-1c067m4-0"
})(["", " user-select:none;"], (0, _styledSystem.variant)({
  variants: TOAST_VARIANTS
}));
//# sourceMappingURL=Toast.js.map